import { Observable } from 'rxjs';
import { MenuItemModel } from '../../models';


export abstract class BaseNavigationService {

  public abstract getMenuItems(menuNames: string[]): Observable<{}>;
}
